import { createAsyncThunk } from '@reduxjs/toolkit';
import { Hexabase } from 'hexabase-sdk';
import { medicalService } from 'services';
import { newMedicalItem, RegisterMedicalError, RegisterMedicalResponse, ThunkAPI } from 'types';

export const getMedicalWithCode = createAsyncThunk<any, string>('medicalInstitution/getListItems', async (params) => {
  try {
    let list_medical_institution = await Hexabase.items().getItemsAsync({
      project_id: 'CPAP',
      datastore_id: 't_medical_institution',
      per_page: 1,
      page: 1,
      use_display_id: true,
      sort_field_id: 'facility_code',
      sort_order: 'desc',
      conditions: params
        ? [
            {
              search_value: [params],
              data_type: 'text',
              id: 'facility_code',
              exact_match: false,
              include_null: true,
            },
          ]
        : undefined,
    });
    return list_medical_institution.items;
  } catch (e) {
    console.log(e);
  }
});

export const getDataStoreFieldMedicals = createAsyncThunk<any, { appId: string; dataStoreId: string }>(
  'register/getDataStoreFieldMedicals',
  async (params) => {
    const response = await medicalService.getDataStoreFieldMedicals(params);
    return response;
  },
);

export const medicalNewItem = createAsyncThunk<RegisterMedicalResponse, newMedicalItem, ThunkAPI<RegisterMedicalError>>(
  'register/newMedical',
  async (params) => {
    const { data } = await medicalService.medicalItem(params);
    return data;
  },
);

export const getCountFacilityCode = createAsyncThunk<any, string>(
  'medical-register/getCountFacilityCode',
  async (payment_method) => {
    const response = await medicalService.getCountFacilityCode(payment_method);
    return response === [] ? null : response;
  },
);

export const updateCountFacilityCode = createAsyncThunk<boolean, any>(
  'medical-register/updateCountFacilityCode',
  async (param) => {
    const response = await medicalService.updateCountFacilityCode(param);
    return response ? true : false;
  },
);
